import React, {useContext} from 'react';
import {Typeahead as T} from 'react-bootstrap-typeahead';
import styled from 'styled-components';
import {ThemeContext} from '../../apiContexts';
import {shadows} from '../../styleVariables';

const Typeahead = styled(T)`
  .rbt-input-main {
    box-shadow: ${shadows.shadow};
    border-radius: 10px;
    padding-right: 3rem !important;
  }
  .rbt-input-hint {
    width: calc(100% - 3rem);
    overflow-x: hidden !important;
  }
`;

const Icon = styled.span`
  color: ${({theme}) => theme};
  position: absolute;
  right: 1rem;
  font-size: 1.3rem;
`;

const Style = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

const SearchAutocomplete = ({className, ...props}) => {
  const theme = useContext(ThemeContext);

  return (
    <Style className={className}>
      <Typeahead {...props} />
      <Icon theme={theme} className="far fa-search" />
    </Style>
  );
};

export default SearchAutocomplete;
